import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'moment'})
export class MomentPipe implements PipeTransform {
  transform(value: number, format:string = 'DD.MM.YYYY HH:mm'): any {
    return value ? moment(value,'X').format(format) : '';
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/pipes/moment.pipe.ts